module.exports = __webpack_public_path__ + "img/user-banner.329bb0f6.jpg";